import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConfirmationDialogParams } from "./confirmation-dialog.interface";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
  standalone: false,
})
export class ConfirmationDialogComponent implements OnInit {
  readonly hasBody: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogParams) {
    this.hasBody = Boolean(data.body || data.additionalInfo);
  }

  ngOnInit(): void {}
}
